<template>
	<van-popup v-model="show" position="bottom" class="virtual-phone-number-popup" closeable>
		<div class="content-box">
			<div class="top-bg">
				<img :src="isFixaddressIng?require('@/assets/image/fixaddress-ing-topbg.png'):(afterAddressData.type==='start'?require('@/assets/image/fixaddress-start-topbg.png'):require('@/assets/image/fixaddress-end-topbg.png'))" style="width:100%;height:100%;" alt="">
			</div>
			<div style="padding:170px 12px 0;">
				<div style="display:flex;align-items:center;">
					<div style="font-size:24px;">{{isFixaddressIng?'修改请求待确认':'是否确定修改地址'}}</div>
					<div class="cancel-fix" v-if="isFixaddressIng" @click="handleCancelFix">取消地址修改</div>
				</div>
				<div class="tip" v-if="isFixaddressIng">
					<span>修改地址请求已提交，待司机师傅确认修改；如长时间未响应</span>
					<span style="color:#FFBD2D;">可尝试联系司机；</span>
				</div>
				<div class="tip" v-else>
					<span>修改新地址后修改</span>
					<span style="color:#FFBD2D;">总里程{{costInfo.mileage<0?'减少':'增加'}}{{Math.abs(costInfo.mileage)}}公里，</span>
					<span>{{costInfo.amount === 0?'可免费修改；':`需补付${costInfo.amount}元里程费用；`}}</span>
				</div>
				<div style="display:flex;align-items:center;margin-bottom:16px;">
					<div style="font-size:14px;">多出里程补交费用：</div>
					<div style="margin-left:auto;color:#EC892E;" @click="handleToDetail">
						<span style="font-size:12px;" v-if="costInfo.amount>0">￥</span>
						<span style="font-size:18px;">{{costInfo.amount==0?'免费':costInfo.amount}}</span>
						<van-icon name="arrow" size="14" color="#C9C2BB"/>
					</div>
				</div>
				<div class="address-info">
					<div class="before">
						<img src="@/assets/image/address-before-bg.png" class="address-img" alt="">
						<div class="address-text" style="color:#669EE6;">{{beforeAddressData.title?beforeAddressData.title:''}}{{beforeAddressData.remark?beforeAddressData.remark:''}}</div>
						<div style="font-size:14px;color:#85807B;position:absolute;z-index:2;bottom:8px;left:16px;">修改前</div>
					</div>
					<img src="@/assets/image/address-arrow.png" class="arrow-icon" alt="">
					<div class="after">
						<img src="@/assets/image/address-after-bg.png" class="address-img" alt="">
						<div class="address-text" style="color:#FFB246;padding-left:10px;">{{afterAddressData.title?afterAddressData.title:''}}{{afterAddressData.remark?afterAddressData.remark:''}}</div>
						<div style="font-size:14px;color:#85807B;position:absolute;z-index:2;bottom:8px;left:16px;">修改后</div>
					</div>
				</div>
				<div class="footer">
					<van-button type="primary" class="cancel" @click="handleOpenAddPrice">补偿司机</van-button>
					<van-button type="primary" class="confirm" @click="handleSubmit">{{isFixaddressIng?'联系司机':(costInfo.amount===0?'免费修改':`支付${costInfo.amount}元修改`)}}</van-button>
				</div>
			</div>
		</div>
		<!-- 补偿司机弹窗 -->
		<addPrice-popup ref="addPricePopup" @confirmPrice="handleConfirmPrice"/>
		<!-- 是否确认取消修改地址弹窗 -->
		<van-popup v-model="isShowPopup" position="center" :style="{ borderRadius: '4px',width:'80%' }">
			<div class="popup-body">
				<div class="popup-title">取消修改地址</div>
				<div class="popup-content">是否取消修改地址申请，确认取消后，已支付金额将原路径返还；</div>
			</div>
			<div class="popup-footer">
				<van-button type="primary" class="cancel" @click="isShowPopup=false">返回</van-button>
				<van-button type="primary" class="confirm" style="flex:1;" @click="handleCancelSubmit">确认取消</van-button>
			</div>
		</van-popup>
		<!-- 费用明细弹窗 -->
		<van-popup v-model="isShowDetailPopup" closeable position="bottom">
			<div class="price-body">
				<div class="price-title">修改地址费用明细</div>
				<div style="display:flex;align-items:center;">
					<div>
						<span style="font-size:14px;color:#3D3833;">修改地址产生费用：</span>
						<span style="font-size:12px;color:#F1892E;" v-if="costInfo.amount>0">￥</span>
						<span style="font-size:18px;color:#F1892E;">{{costInfo.amount===0?'免费':costInfo.amount}}</span>
					</div>
					<div @click="handleToRule"
					style="
						padding: 5px 12px;
						border: 1px solid #C9C2BB;
						border-radius: 4px;
						font-size: 12px;
						line-height: 12px;
						margin-left: auto;
					"
					>
					<img
						src="@/assets/image/feerules-icon.png"
						style="
						display: inline-block;
						width: 13px;
						height: 12px;
						margin-right: 4px;
						vertical-align: -2px;
						"
					/>
					<span>收费规则</span>
					</div>
				</div>
				<div class="price-list" v-if="feeList.length > 0">
					<div class="price-items" v-for="(item,index) in feeList" :key="index">
						<div style="color: #393939;">
							{{item.name}}
						</div>
						<div style="color: #EC892E;margin-left: auto;">
							￥{{item.value}}
						</div>
					</div>
				</div>
			</div>
		</van-popup>
	</van-popup>
</template>

<script>
	import {mapState} from 'vuex';
	import {apicanFixAddressFlag,apicreateFixOrder,apicompensateDriver,apirefundFixAddress,apiCancelFixAddressOrder} from "@/api/beecargo/addressBook/logisticsDetails/index.js";
	import addPricePopup from './addPrice-popup.vue';
    import { Toast ,Popup ,Button ,Icon   } from 'vant';
	export default {
        components:{
            Toast,
            Popup,
            [Button.name]:Button,
            [Icon.name]:Icon,
			addPricePopup
        },
		data(){
			return {
				show:false,
				isShowPopup:false,//是否显示取消修改地址提示弹窗
				isShowDetailPopup:false,//是否显示修改地址费用明细
				feeList:[
					// {name:'里程费用',value:100.00},
				],//收费项
				beforeAddressData:{},//修改前地址
				afterAddressData:{},//修改后地址
				costInfo:{},//费用信息
				copyAmount:0,//原修改地址金额
				orderId:null,//订单ID
				key:new Date().format("yyyyMMddhhmmss"),//计算/创建订单key
				shippingInfo:[],
				receivingInfo:[],
				addPrice:0,//加价补偿司机金额
				isFixaddressIng:false,//是否正在修改
				tranQueryId:null,//支付单ID
				orderNo:null,//订单NO
				cost:{},//费用信息
				payType:'',//订单支付类型
			}
		},
		computed:{
			...mapState(['fixAddress']),
		},
		methods:{
			async init(afterAddressData,fixIngFlag,cost,tranQueryId,orderMeil,payType){
				// afterAddressData : 修改后的地址
				// fixIngFlag ： 是否处于修改中
				// cost : 修改地址中的费用信息
				// tranQueryId : 原订单ID
				// orderMeil : 原订单里程数
				// payType : 订单支付类型
				Toast.loading({
					message: '加载中...',
					forbidClick: true,
					duration:0
				});
				this.isFixaddressIng = fixIngFlag?fixIngFlag:false;
				this.beforeAddressData = this.fixAddress.fixAddressData;
				this.afterAddressData = afterAddressData;
				this.shippingInfo = JSON.parse(JSON.stringify(this.fixAddress.shippingInfo));
				this.receivingInfo = JSON.parse(JSON.stringify(this.fixAddress.receivingInfo));
				if(afterAddressData.type === 'start'){
					// 将要修改的地址替换掉原来的地址
					this.shippingInfo[this.fixAddress.fixAddressIndex] = afterAddressData;
				}else if(afterAddressData.type === 'end'){
					// 将要修改的地址替换掉原来的地址
					this.receivingInfo[this.fixAddress.fixAddressIndex] = afterAddressData;
				}
				this.orderId = afterAddressData.id;
				this.cost = cost;
				this.tranQueryId = tranQueryId;
				this.payType = payType;
				if(fixIngFlag){
					Toast.clear();
					if(cost && cost.modifyAddrOrder){
						this.feeList = [
							{name:'里程费用',value:cost.modifyAddrOrder.mileageAmount.toFixed(2)},
							{name:'发票费用',value:cost.modifyAddrOrder.invoiceAmount.toFixed(2)},
						]
						if(cost.modifyAddrOrder.userModifyCompensateAmount > 0){
							this.feeList.push({name:'加价补偿费用',value:cost.modifyAddrOrder.userModifyCompensateAmount.toFixed(2)})
						}
						let addPirce = 0;
						if(cost.markUpAddrOrderList && cost.markUpAddrOrderList.length > 0){
							let result = [];
							cost.markUpAddrOrderList.map(item=>{
								result.push(item.userModifyCompensateAmount);
							})
							this.feeList.push({name:'补偿司机',value:this.$math(0,...result).add()})
							addPirce = this.$math(0,...result).add();
						}
						this.costInfo = {amount:this.$math(cost.modifyAddrOrder.orderAmount,addPirce).add(),...cost.modifyAddrOrder};

					}
					this.show = true;
				}else{
					// 判断订单是否可以修改地址
					await apicanFixAddressFlag({
						orderId:afterAddressData.id,
						key:this.key,
						shippingInfo:this.shippingInfo,
						receivingInfo:this.receivingInfo,
						userModifyCompensateAmount:this.addPrice>0?this.addPrice:null
					}).then(res=>{
						Toast.clear();
						if(!res.data.canChangeEnd){
							return Toast(res.data.msg);
						}
						this.feeList = [
							{name:'里程费用',value:res.data.mileageAmount},
							{name:'发票费用',value:res.data.invoiceAmount},
						]
						this.copyAmount = res.data.amount;
						res.data.mileage = Number(this.$math(res.data.mileage,orderMeil?orderMeil:0).subtract());

						res.data.mileage = (res.data.mileage/1000).toFixed(2);


						this.costInfo = res.data;
						this.show = true;
					})
				}
			},
			// 里程费规则
			handleToRule(){
				let query = this.$route.query;
				this.$router.push(`/beecargo/loadingUnloadingChargingRules?orderSource=${query.isUser=='1'?'app':'app_vip'}&accessToken=${query.token?query.token:query.accessToken}&machineCode=${query.machineCode}`)
			},
			async handleSubmit(){
				if(this.isFixaddressIng){
					return this.$emit('callPhone',this.afterAddressData.type);
				}
				// 需要创建支付单
				let res = await apicreateFixOrder({
					orderId:this.orderId,
					key:this.key,
					shippingInfo:this.shippingInfo,
					receivingInfo:this.receivingInfo,
					userModifyCompensateAmount:this.addPrice>0?this.addPrice:null
				})
				if(this.payType === 'ONLINE'){
					if(this.costInfo.amount > 0){
						// 跳转支付
						window.uni.redirectTo({
							url:`/packHome/orderPay/index?orderId=${res.data.id}&totalAmount=${this.costInfo.amount}&isFixAddress=1&tranOrderId=${this.orderId}&tmsOrderId=${this.orderId}`
						})
					}else{
						// 费用为0时创建订单就修改成功
						Toast({
							message:'修改成功',
							onClose:()=>{
								this.$router.go(-1);
							}
						})
					}
				}else{
					// 到付订单创建订单就修改成功
					Toast({
						message:'修改成功',
						onClose:()=>{
							this.$router.go(-1);
						}
					})
				}
			},
			handleOpenAddPrice(){
				this.$refs.addPricePopup.init({title:'补偿司机'});
			},
			// 补偿司机多少钱
			async handleConfirmPrice(price){
				if(this.isFixaddressIng){
					let res = await apicompensateDriver({
						correlationOrderNo:this.tranQueryId,
						userModifyCompensateAmount:price
					})
					if(this.payType === 'ONLINE'){
						this.show = false;
						// 跳转支付
						window.uni.navigateTo({
							url:`/packHome/orderPay/index?orderId=${res.data.id}&totalAmount=${price}&isFixAddress=1&isCompensate=1&tranOrderId=${this.orderId}&tmsOrderId=${this.orderId}`
						})
					}else{
						let addPirce = 0;
						if(this.cost.markUpAddrOrderList && this.cost.markUpAddrOrderList.length > 0){
							let result = [];
							this.cost.markUpAddrOrderList.map(item=>{
								result.push(item.userModifyCompensateAmount);
							})
							result.push(price);
							let findIndex = this.feeList.findIndex(item=>item.name === '补偿司机');
							if(findIndex >= 0){
								this.feeList[findIndex] = {name:'补偿司机',value:Number(this.$math(0,...result).add())};
							}else{
								this.feeList.push({name:'补偿司机',value:this.$math(0,...result).add()})
							}
							addPirce = this.$math(0,...result).add();
						}
						this.costInfo = {amount:Number(this.$math(this.cost.modifyAddrOrder.orderAmount,addPirce).add()),...this.cost.modifyAddrOrder};
						Toast({
							message:'补偿司机操作成功',
						})
					}
				}else{
					let findIndex = this.feeList.findIndex(item=>item.name === '补偿司机')
					if(findIndex > -1){
						this.feeList[findIndex] = {name:'补偿司机',value:price};
					}else{
						this.feeList.push({name:'补偿司机',value:price});
					}
					this.$set(this.costInfo,'amount',this.$math(this.copyAmount,price).add());
					this.addPrice = price;
				}
			},
			// 取消修改地址
			handleCancelFix(){
				this.isShowPopup = true;
			},
			// 查看费用明细
			handleToDetail(){
				this.isShowDetailPopup = true;
			},
			// 确认取消修改地址
			async handleCancelSubmit(){
				if(this.payType === 'ONLINE'){
					// 退款
					await apirefundFixAddress({orderNo:this.tranQueryId})
				}else{
					// 到付订单取消修改地址
					await apiCancelFixAddressOrder({orderNo:this.tranQueryId,reason:'取消修改地址'})
				}
				Toast({message:'取消成功'})
				this.isShowPopup = false;
				this.show = false;
				this.$emit('getDetail')
			}
		},
	}
</script>

<style scoped lang="scss">
	.content-box {
		width: 100%;
		.top-bg {
			width: 100%;
			height: 214px;
			position: absolute;
			top: 0;
			left: 0;
			z-index: -1;
		}
		.tip {
			font-size: 14px;
			color: #85807B;
			margin-top: 10px;
			margin-bottom: 30px;
		}
		.rule {
			width: 100%;
			height: 128px;
			margin-bottom: 24px;
		}
		.cancel-fix {
			font-size: 12px;
			color:#85807B;
			border: 1px solid #C9C9C9;
			border-radius: 4px;
			padding: 6px 4px;
			margin-left: auto;
		}
		.address-info {
			width: 100%;
			height: 89px;
			margin-bottom: 24px;
			position: relative;
			.before,.after {
				width: 52%;
				height: 89px;
				position: relative;
				padding: 8px 16px;
				box-sizing: border-box;
			}
			.after {
				position: absolute;
				right: 0;
				top: 0;
			}
			.arrow-icon {
				width:36px;
				height:15px;
				position:absolute;
				top:50%;
				left:50%;
				z-index:3;
				transform: translate(-50%,-50%);
			}
			.address-img {
				width:100%;
				height:89px;
				position: absolute;
				top: 0;
				left: 0;
				z-index: 1;
			}
			.address-text {
				font-size: 18px;
				position: relative;
				z-index: 2;
				overflow: hidden;
				word-break: break-all;
				text-overflow: ellipsis; 
				display: -webkit-box; // 弹性伸缩盒
				-webkit-box-orient: vertical; // 设置伸缩盒子元素排列方式
				-webkit-line-clamp: 2;
				margin-bottom: 6px;
			}
		}
		.footer {
			display: flex;
			justify-content: space-between;
			margin-bottom: 30px;
		}
	}
	.cancel {
		flex: 1;
		height: 38px;
		border: 1px solid #EC892E;
		border-radius: 4px;
		color: #EC892E;
		background-color: #ffffff;
		margin-right: 16px;
	}
	.confirm {
		flex: 2;
		height: 38px;
		background-color: #EC892E;
		border-radius: 4px;
		color: #ffffff;
		border: 1px solid #EC892E;
	}
	.popup-body {
		padding: 24px 20px;
		.popup-title {
			color: #3D3833;
			font-size: 18px;
			text-align: center;
		}
		.popup-content {
			color: #3D3833;
			font-size: 14px;	
			margin-top: 20px;
			margin-bottom: 10px;
			line-height: 24px;
			letter-spacing: 1px;
		}
	}
	.popup-footer {
		display: flex;
		align-items: center;
		padding: 0 20px 20px;
	}
	.price-body {
		padding: 16px 12px;
		.price-title {
			color: #3D3833;
			font-size: 14px;
			margin-bottom: 14px;
		}
	}
	.price-list {
		background-color: #F8F8F8;
		border-radius: 4px;
		padding: 8px 16px;
		max-height: 300px;
		overflow-y: auto;
		box-sizing: border-box;
		margin-top: 24px;
		.price-items {
			padding: 16px 0;
			border-bottom: 1px solid #EBE5E0;
			display: flex;
			align-items: center;
			font-size: 16px;
			line-height: 16px;
			&:last-child {
				border: none;
			}
		}
	}
</style>